<div class="card tile-shadow h-100">
  <div class="card-header bg-white header">
    <div class="row">
      <div class="col-10">
        <h3 class="fw-bold">Last Payroll</h3>
        <small>{{ payroll.PayDate | date: 'MM/dd/yyyy' }} - {{ payroll.Frequency }}</small>
      </div>
      <div class="col-2 text-end">
        <img src="assets/icons/money-page.svg" />
      </div>
    </div>
  </div>
  <div class="list-group list-group-flush h-75">
    <div class="list-group-item d-flex justify-content-between row-height align-middle">
      <span class="fw-bold mt-auto mb-auto">Total Debit Amount</span>
      <span class="mt-auto mb-auto">{{ payroll.TotalDebitAmount | currency }}</span>
    </div>
    <div class="list-group-item d-flex justify-content-between row-height">
      <span class="fw-bold mt-auto mb-auto">Total Cost of Payroll</span>
      <span class="mt-auto mb-auto">{{ payroll.TotalCostOfPayroll | currency }}</span>
    </div>
    <div class="list-group-item d-flex justify-content-between row-height">
      <span class="fw-bold mt-auto mb-auto"># Employees Paid</span>
      <span class="mt-auto mb-auto" *ngIf="payroll.TotalNoEesPaid > 1"
        >{{ payroll.TotalNoEesPaid }} people</span
      >
      <span class="mt-auto mb-auto" *ngIf="payroll.TotalNoEesPaid == 1"
        >{{ payroll.TotalNoEesPaid }} person</span
      >
    </div>
  </div>
</div>
